import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ToastViewportProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { ToastViewport } from "reka-ui"
import { cn } from "@/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastViewport',
  props: {
    hotkey: {},
    label: { type: [String, Function] },
    asChild: { type: Boolean },
    as: {},
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, "class")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ToastViewport), _mergeProps(_unref(delegatedProps), {
    class: _unref(cn)('fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]', props.class)
  }), null, 16, ["class"]))
}
}

})